// extracted by mini-css-extract-plugin
module.exports = {"container":"Markets_container__fqzL2","title":"Markets_title__pKtRS","content":"Markets_content__H99Nl","col1":"Markets_col1___CGAN","col2":"Markets_col2__POOAz"};